import type { Client } from '@halo/chat-sdk';
import { type StateCreatorEnhance } from '@halo/zustand-enhance';
import type { Session } from '@halo/chat-sdk';
import { type RequiredSome } from '@halo/utils';
import type { SessionStore } from './main';

export interface SessionStateStore {
  active_at: number;
  client: Client;
  session: Session | null;
  ready: boolean;
  activated: boolean;
  scrollCache: number | undefined;
  createSessionState: (options: CreateSessionStateOptions) => () => void;
  setSession: (session: Session) => void;
  setActivated: (activated: boolean) => void;
  setScrollCache: (scrollCache: number) => void;
}

export type CreateSessionStateOptions = RequiredSome<SessionStateStore, 'client' | 'session'>;

export const sessionStoreCreator: StateCreatorEnhance<SessionStore> = (set, get) =>
  ({
    active_at: 0,
    client: null,
    session: null,
    ready: false,
    activated: true,
    scrollCache: 0,
    createSessionState: (options: CreateSessionStateOptions) => {
      set(options);
    },
    setSession: (session) => {
      set({ session });
    },
    setActivated: (activated) => {
      set({ activated, active_at: Date.now() });
    },
    setScrollCache: (scrollCache) => {
      const store = get();
      store.scrollCache = scrollCache;
    },
  }) as SessionStore;
